import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudInstancesServer = () => import('./staff/crudInstancesServer')
const ViewStaffCrudInstancesSystem = () => import('./staff/crudInstancesSystem')
const ViewStaffCrudInstancesSystemOthers = () => import('./staff/crudInstancesSystemOthers')
const ViewStaffCrudInstancesSystemDocker = () => import('./staff/crudInstancesSystemDocker')
const ViewStaffCrudInstancesCategories = () => import('./staff/crudInstancesCategories')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'InstancesStaffDashboard',
  crudInstancesServer: 'InstancesStaffCrudInstancesServer',
  crudInstancesSystem: 'InstancesStaffCrudInstancesSystem',
  crudInstancesSystemOthers: 'InstancesStaffCrudInstancesSystemOthers',
  crudInstancesSystemDocker: 'InstancesStaffCrudInstancesSystemDocker',
  crudInstancesCategories: 'InstancesStaffCrudInstancesCategories',
}

const router =
  [
    {
      path: '/st/instances',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Instancias',
          }          
        },  
        {
          path: 'server',
          name: VIEWS.crudInstancesServer,
          component: ViewStaffCrudInstancesServer,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Servidores',
          }
        },  
        {
          path: 'system',
          name: VIEWS.crudInstancesSystem,
          component: ViewStaffCrudInstancesSystem,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Instancias - Zyncro',
          }
        },         
        {
          path: 'others-system',
          name: VIEWS.crudInstancesSystemOthers,
          component: ViewStaffCrudInstancesSystemOthers,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Instancias - Laravel',
          }
        },                 
        {
          path: 'docker-system',
          name: VIEWS.crudInstancesSystemDocker,
          component: ViewStaffCrudInstancesSystemDocker,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Instancias - Docker',
          }          
        },                         
        {
          path: 'categories',
          name: VIEWS.crudInstancesCategories,
          component: ViewStaffCrudInstancesCategories,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM Categorías de Servidores',
          }          
        },                  
      ]
    },

    {
      path: '/cu/instances',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/instances',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
